import { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// @mui material components
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import ImageUpload from "components/CustomUpload/ImageUpload";

import {
	ADD_NEIGHBORHOOD_CHANNEL,
	DELETE_NEIGHBORHOOD_CHANNEL,
	REORDER_NEIGHBORHOOD_CHANNELS,
	REMOVE_NEIGHBORHOODMAP_IMAGE,
	REMOVE_NEIGHBORHOOD_IMAGE,
	SET_NEIGHBORHOODMAP_FILES_IMAGES,
	SET_NEIGHBORHOOD_CUSTOM_URI,
	SET_NEIGHBORHOOD_CUSTOM_URI_ERROR,
	SET_NEIGHBORHOOD_FILES_IMAGES,
	SET_NEIGHBORHOOD_NAME,
	SET_NEIGHBORHOOD_NAME_ERROR,
	SET_NEIGHBORHOOD_PRIVATE,
	SET_NEIGHBORHOOD_REGISTER_KEY,
	SET_NEIGHBORHOOD_VISIBLE
} from "actions/types";
import {
	fetchSearchNeighborhoodCityChannels,
	fetchSearchOrganizationChannels
} from "actions/channel";

import SortableTags from "components/DigiHapi/SortableTags";

class Step1 extends Component {
	sendState() {
		return this.state;
	}

	isValidated() {
		const { dispatch, name, customUri } = this.props;

		let success = true;
		if (!name || name.trim().length === 0) {
			dispatch({
				type: SET_NEIGHBORHOOD_NAME_ERROR
			});
			success = false;
		}
		if (!customUri || customUri.trim().length === 0) {
			dispatch({
				type: SET_NEIGHBORHOOD_CUSTOM_URI_ERROR
			});
			success = false;
		}
		return success;
	}

	onImageLoaded = (name, imagePreviewUrl) => {
		const { dispatch } = this.props;
		dispatch({
			type: SET_NEIGHBORHOOD_FILES_IMAGES,
			payload: [{ name, base64: imagePreviewUrl, out: "logoUri" }]
		});
	};

	onImageRemoved = () => {
		this.props.dispatch({
			type: REMOVE_NEIGHBORHOOD_IMAGE
		});
	};

	onNeighborhoodMapLoaded = (name, imagePreviewUrl) => {
		const { dispatch } = this.props;
		dispatch({
			type: SET_NEIGHBORHOODMAP_FILES_IMAGES,
			payload: [
				{
					name,
					base64: imagePreviewUrl,
					ignoreQualityTransform: true,
					out: "mapUri"
				},
				{ name: name + "-small", base64: imagePreviewUrl, out: "mapSmallUri" }
			]
		});
	};

	onNeighborhoodMapRemoved = () => {
		this.props.dispatch({
			type: REMOVE_NEIGHBORHOODMAP_IMAGE
		});
	};

	handleDelete = index => {
		const { dispatch } = this.props;

		if (index >= 0) {
			dispatch({
				type: DELETE_NEIGHBORHOOD_CHANNEL,
				index
			});
		}
	};

	handleReorder = (from, to) => {
		this.props.dispatch({
			type: REORDER_NEIGHBORHOOD_CHANNELS,
			from,
			to
		});
	};

	handleAddition = channel => {
		const { dispatch } = this.props;
		dispatch({
			type: ADD_NEIGHBORHOOD_CHANNEL,
			value: channel
		});
	};

	onInput = query => {
		const {
			organizationId,
			ignoreWeather,
			fetchSearchOrganizationChannels,
			fetchSearchNeighborhoodCityChannels
		} = this.props;
		if (query?.length > 2) {
			organizationId
				? fetchSearchOrganizationChannels(query, organizationId, ignoreWeather)
				: fetchSearchNeighborhoodCityChannels(query, ignoreWeather);
		}
	};

	handleToggle = () => {
		this.props.dispatch({
			type: SET_NEIGHBORHOOD_VISIBLE,
			value: !this.props.isVisible
		});
	};

	handleTogglePrivate = () => {
		this.props.dispatch({
			type: SET_NEIGHBORHOOD_PRIVATE,
			value: !this.props.isPrivate
		});
	};

	render() {
		const {
			dispatch,
			name,
			nameErrorMsg,
			customUri,
			customUriErrorMsg,
			logoUri,
			mapSmallUri,
			registerkey,
			channels,
			channelsSuggestions,
			isPrivate,
			isVisible
		} = this.props;

		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12} sm={4}>
					<MDTypography component="div" variant="h6" mb={1}>
						Logo
					</MDTypography>
					<ImageUpload
						onImageLoaded={this.onImageLoaded}
						onImageRemoved={this.onImageRemoved}
						photoUri={logoUri}
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<MDTypography component="div" variant="h6" mb={1}>
						Plan intéractif
					</MDTypography>
					<ImageUpload
						onImageLoaded={this.onNeighborhoodMapLoaded}
						onImageRemoved={this.onNeighborhoodMapRemoved}
						photoUri={mapSmallUri}
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<FormControlLabel
						control={
							<Checkbox
								checked={!!isPrivate}
								onChange={this.handleTogglePrivate}
							/>
						}
						label="Cummunauté privé"
					/>
				</Grid>
				<Grid item xs={12} sm={4}>
					<FormControlLabel
						control={
							<Checkbox checked={!!isVisible} onChange={this.handleToggle} />
						}
						label="Visible pour les voisins"
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Nom *"
						id="name"
						fullWidth
						error={!!nameErrorMsg}
						helperText={nameErrorMsg}
						value={name ? name : ""}
						onChange={e =>
							dispatch({
								type: SET_NEIGHBORHOOD_NAME,
								value: e.target.value
							})
						}
						autoComplete="new-password"
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="URI *"
						id="uri"
						fullWidth
						error={!!customUriErrorMsg}
						helperText={customUriErrorMsg}
						value={customUri ? customUri : ""}
						onChange={e =>
							dispatch({
								type: SET_NEIGHBORHOOD_CUSTOM_URI,
								value: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Clé pour rejoindre la communauté de voisinage"
						id="registerkey"
						fullWidth
						value={registerkey ? registerkey : ""}
						onChange={e =>
							dispatch({
								type: SET_NEIGHBORHOOD_REGISTER_KEY,
								value: e.target.value
							})
						}
						autoComplete="new-password"
					/>
				</Grid>
				<Grid item xs={12}>
					<MDBox width="100%">
						<FormHelperText>
							{
								"Canaux de diffusion depuis lesquelles recevoir publications, bons plans et météo"
							}
						</FormHelperText>
						<SortableTags
							placeholderText="Canaux de diffusion ..."
							tags={channels}
							suggestions={channelsSuggestions}
							minQueryLength={3}
							maxSuggestionsLength={10}
							onDelete={this.handleDelete}
							onAddition={this.handleAddition}
							onReorder={this.handleReorder}
							suggestionsFilter={() => true}
							onInput={this.onInput}
							removeButtonText="Cliquez pour retirer"
							inputAttributes={{
								autoComplete: "new-password"
							}}
						/>
					</MDBox>
				</Grid>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		name,
		visible,
		nameErrorMsg,
		customUri,
		customUriErrorMsg,
		logoUri,
		mapSmallUri,
		registerkey,
		channels,
		channelsSuggestions,
		ignoreWeather,
		organizationId,
		isVisible,
		isPrivate
	} = state.neighborhoodReducer;

	return {
		name,
		visible,
		nameErrorMsg,
		customUri,
		customUriErrorMsg,
		logoUri,
		mapSmallUri,
		registerkey,
		channels: Object.values(channels),
		channelsSuggestions: Object.values(channelsSuggestions),
		ignoreWeather,
		organizationId,
		isVisible,
		isPrivate
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchSearchNeighborhoodCityChannels,
			fetchSearchOrganizationChannels
		},
		dispatch
	);
	return { ...actions, dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
	forwardRef: true
})(Step1);
